<template>
  <div :style="{height: '100%'}">
    <stub />

    <kanban v-if="mode==='board'" />
    <list-view v-if="mode==='list'" />

    <workload v-if="mode==='workload'" />
    <resources v-if="mode==='resources'" />
    <overview v-if="mode==='overview'" />

    <export v-if="mode==='export'" />

    <router-view />
  </div>
</template>

<script>
import routerGuard from '../../router/guards';
import projectsModel from '../../models/projects';
import Kanban from '../kanban/Kanban.vue';
import Workload from './workloadPage/workloadPage.vue';
import Export from '../export/Export.vue';
import ProjectOverview from '../overview/ProjectOverview.vue';
import ProjectResources from '../resources/main.vue';
import listView from '../listView/listView.vue';
import stub from '../stubs/stubPage.vue';

export default {
  name: 'ProjectPage',

  components: {
    kanban: Kanban,
    workload: Workload,
    export: Export,
    resources: ProjectResources,
    'list-view': listView,
    overview: ProjectOverview,
    stub,
  },
  beforeRouteUpdate: routerGuard.guard,
  props: {
    mode: {
      type: String,
      default: 'gantt',
    },
  },

  computed: { },

  watch: {
    mode(mode) {
      projectsModel.setActiveProjectMode(mode);
    },
  },

  mounted() {
    projectsModel.setActiveProjectMode(this.mode); // init render
  },
};
</script>

<style scoped>

</style>
